import React from 'react'
import useWindowSize from '../../utils/windowUtils'
import { getDomaiGetQuote, getDomainOneInc } from '../../services/Utils'
import { updateOneIncTokens } from '../../services/Api'
import { useState, useEffect } from 'react'

const buttonStyle = {
    background: '#ff8000',
    borderColor: '#ff8000',
    padding: '6px 15px',
    marginBottom: '15px',
    borderRadius: '25px'
}

const RenewalAlert = (props) => {
    const userData = props.userData
    const {policyNumber, zip, env } = userData
    const [paymentToken, setPaymentToken] = useState("")
    const checkOneIncTokens = async () => {
        let paymentToken
        const updateOneIncTokens_response = await updateOneIncTokens(policyNumber, zip, env, ["payment"], "MyAccountRenewal" )
        paymentToken = updateOneIncTokens_response.Tokens.find(x => x.Type === "payment").Value
        setPaymentToken(paymentToken)
    }

    useEffect(() => {
        checkOneIncTokens()
    },[])
    const { renewalInfo, paymentData } = userData;
    const isSmallDesktop = useWindowSize().width < 768;
    const formattedExpDate = FormatDate(new Date(renewalInfo?.expirationDate));
    const renewalEffectiveDt = !!userData.idCardData[0] && 'effectivedt' in userData.idCardData[0] ? new Date(userData.idCardData[0].effectivedt) : new Date(userData.effectiveDate)
    const dueDt = new Date(userData.paymentData.duedt);
    const isTotalAmtZero = (paymentData.totalamt === "N/A" || paymentData.totalamt === "No payment due." || paymentData.totalamt === "0.00"  || paymentData.totalamt === "0");
    
    if(userData.state !== "Michigan" || renewalInfo.pipOption === 0){
        return null;
    }

    const handleOnClick = (token) => {
        window.open(`https://${getDomaiGetQuote()}/renewal/mi/Renewal_0LoadPolicy.aspx?token=${token}&access=My%20Account`, '_blank');
    }

    const handleOneIncOnClick = (pixelID) => {
        window.location.replace(`https://${getDomainOneInc()}/?Token=${paymentToken}`)
    }

    return (
        <>
            {(
                !isSmallDesktop ?
                    <hr className='mt-0 mb-3' /> :
                    null
            )}
            {(
                renewalInfo.daysUntilRenewal > 37 ? // Up to 50 days
                    (
                        !renewalInfo.hasCompletedRenewal && renewalInfo.pipOption > 3 ?
                            <div className={(isSmallDesktop ? 'px-2 mb-3' : 'px-2 mb-5')} style={{ fontSize: '.9em', lineHeight: (isSmallDesktop ? '1.3' : '') }}>
                                <h6 className='text-center' style={{ color: '#2C5484', fontWeight: 'bold', fontSize: '1.2em' }}>
                                    No-Fault PIP Coverage: Renewal Certification
                                    <br />
                                    NOTICE: Documents Required
                                </h6>
                                <div className='d-flex' style={{ minHeight: '180px' }}>
                                    <div className='col-5 text-center'>
                                        <img src="https://assets.cure.com/img/main-site/hourglss-2.png" alt="" style={{ width: '80%', maxWidth: '120px' }} />
                                    </div>
                                    <div className='col-7'>
                                        Renewal Date: <br />
                                        {formattedExpDate} 12:01 am

                                        <br /><br />
                                        Current Coverage: <br />
                                        {renewalInfo.coverageDesc}

                                        <br /><br />
                                        <button className='btn btn-primary' style={buttonStyle} onClick={() => handleOnClick(renewalInfo.renewalToken)}>LET'S GET STARTED</button>
                                    </div>
                                </div>
                                <div>
                                    Easily upload documents to maintain your coverage. Failure to do so will result in the change to a higher No-Fault PIP option and <strong>increase your premium at time of renewal</strong>.
                                    <br /><br />
                                    A payment will be required to renew your policy. Your Renewal Offer will be sent 37 days prior to the renewal date.
                                </div>
                            </div> :
                            null
                    ) :
                    (
                        !renewalInfo.hasCompletedRenewal && renewalInfo.pipOption > 3 && renewalInfo.renewalPIPOption < 4 ? // Up to 37 days
                            <div className={(isSmallDesktop ? 'px-2 mb-3' : 'px-2 mb-5')} style={{ fontSize: '.9em', lineHeight: (isSmallDesktop ? '1.3' : '') }}>
                                <h6 className='text-center' style={{ color: '#2C5484', fontWeight: 'bold', fontSize: '1.2em' }}>
                                    No-Fault PIP Coverage: Renewal Certification
                                    <br />
                                    NOTICE: Your documents are past due.
                                </h6>
                                <div className='d-flex' style={{ minHeight: '180px' }}>
                                    <div className='col-5 text-center'>
                                        <img src="https://assets.cure.com/img/main-site/hourglss-1.png" alt="" style={{ width: '80%', maxWidth: '120px' }} />
                                    </div>
                                    <div className='col-7'>
                                        Renewal Date: <br />
                                        {formattedExpDate} 12:01 am

                                        <br /><br />
                                        Current Coverage: <br />
                                        {renewalInfo.coverageDesc}

                                        <br /><br />
                                        <button className='btn btn-primary' style={buttonStyle} onClick={() => handleOnClick(renewalInfo.renewalToken)}>LET'S GET STARTED</button>
                                    </div>
                                </div>
                                <div>
                                    As of today, we have not received or been able to verify your proof of medical coverage. The result is the PIP selection on your Renewal Offer has changed to a higher No-Fault PIP coverage <strong>at an increased premium as required by Michigan law</strong>.
                                    <br /><br />
                                    There is still time to re-establish your preferred coverage option. A payment will be required to renew your policy.
                                </div>
                            </div> : // Payment
                                !(dueDt === renewalEffectiveDt || isTotalAmtZero) ?
                                <div className={(isSmallDesktop ? 'px-2 mb-3' : 'px-2 mb-5')} style={{ fontSize: '.9em' }}>
                                    <h6 className='text-center' style={{ color: '#2C5484', fontWeight: 'bold', fontSize: '1.2em' }}>
                                        Your policy is renewing soon.
                                    </h6>
                                    <div>
                                        By now you should have received your renewal offer, including ID Card(s), Declarations Page and Household Member Letter. Please review to confirm the accuracy and if correct, all that's left is to make your first payment.

                                        <br /><br />
                                        <div className='col-7'>
                                            Renewal Date: <br />
                                            {formattedExpDate} 12:01 am

                                            <br /><br />
                                            Total 6-Month Cost: <br />
                                            {FinalValue(renewalInfo.premium)}
                                        </div>

                                        <br />
                                        <div className='text-center'>
                                            <button className='btn btn-primary' style={buttonStyle} onClick={() => handleOneIncOnClick(renewalInfo.pixelID)}>MAKE RENEWAL PAYMENT</button>
                                        </div>
                                    </div>
                                </div> :
                                null
                    )
            )}

            {(
                isSmallDesktop ?
                    <hr className='mt-0 mb-3' /> :
                    null
            )}
        </>
    )
}

const FormatDate = (tempDate) => {
    var dateMonth = `${(tempDate.getMonth() + 1) < 10 ? '0' : ''}${tempDate.getMonth() + 1}`
    var dateDay = `${(tempDate.getDate() + 1) < 10 ? '0' : ''}${tempDate.getDate()}`
    var dateYear = `${tempDate.getFullYear()}`
    const date = `${dateMonth}/${dateDay}/${dateYear}`
    return date
}

const FinalValue = (value) => {
    if (value !== 'N/A' && value !== 'No payment due.')
        return "$" + value?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    return value
}

export default RenewalAlert